import React from 'react';
import { Helmet } from 'react-helmet-async';

export function SEOHead({ 
  title = 'Scratch Unleashed - Best Night Club in Jamshedpur',
  description = 'Experience premium nightlife at Scratch Unleashed, the best night club in Jamshedpur. World-class DJs, VIP tables, birthday party venue at Bindal Mall, Sonari. Book your table now!',
  keywords = 'night club Jamshedpur, best night club Jamshedpur, DJ night Jamshedpur, party place Jamshedpur, VIP table booking Jamshedpur, birthday party venue Jamshedpur, bar Jamshedpur, nightlife Jamshedpur, clubs near Sonari, Bindal Mall nightlife',
  canonical = null,
  image = 'https://scratchjsr.com/images/scratch-logo.png',
  imageWidth = 512,
  imageHeight = 512,
  type = 'website',
  author = 'Scratch Unleashed',
  publishedTime = null,
  modifiedTime = null,
  noindex = false,
}) {
  const siteUrl = 'https://scratchjsr.com';
  const fullTitle = title.includes('Scratch Unleashed') ? title : `${title} | Scratch Unleashed`;
  // canonical: ONLY emit when the page explicitly passes one. Defaulting to
  // siteUrl was actively harmful — it shipped <link rel="canonical" href="/">
  // into the homepage's prerendered HTML, and because production serves the
  // homepage HTML for every route (no per-route resolution today), Google
  // saw /events, /blog, /faq etc. all claiming to be duplicates of /.
  // Routes that need a canonical (FAQPage, EventsListPage, AboutPage,
  // PromotersLandingPage etc.) set it explicitly via their own <Helmet>.
  const canonicalUrl = canonical || null;
  const hreflangUrl  = canonical || siteUrl;
  const robotsContent = noindex ? 'noindex, nofollow' : 'index, follow';

  return (
    <Helmet>
      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-XTG9J3PWFH"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-XTG9J3PWFH');
        `}
      </script>

      {/* Primary Meta Tags */}
      <html lang="en-IN" />
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <link rel="alternate" hreflang="en-IN" href={hreflangUrl} />
      <link rel="alternate" hreflang="x-default" href={hreflangUrl} />

      {/* Robots */}
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={robotsContent} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content={String(imageWidth)} />
      <meta property="og:image:height" content={String(imageHeight)} />
      <meta property="og:site_name" content="Scratch Unleashed" />
      <meta property="og:locale" content="en_IN" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@scratchunleashed" />
      
      {/* Geo targeting */}
      <meta name="geo.region" content="IN-JH" />
      <meta name="geo.placename" content="Jamshedpur, Jharkhand, India" />
      <meta name="geo.position" content="22.8059;86.1979" />
      <meta name="ICBM" content="22.8059, 86.1979" />

      {/* Additional */}
      <meta name="revisit-after" content="7 days" />
      <meta name="language" content="English" />
      <meta name="country" content="India" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      <meta name="category" content="Nightclub, Bar, Entertainment" />
    </Helmet>
  );
}
